module.exports = __webpack_public_path__ + "img/1.17c5029b.jpg";